<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';

  export let shopMoreDetails;

  const { encodedContextPath } = getAppConfig();

  function contextedUrl(url = '') {
    if (url !== null && url != '' && url.startsWith(encodedContextPath) === false && url.startsWith('http') === false) {
      return `${encodedContextPath}${url}`;
    }
    return url;
  }
</script>

<section class="shop-more-container">
  <div class="left-part">
    <div class="shop-more-label">{shopMoreDetails?.shopMoreLabel}</div>
  </div>
  <div class="right-part">
    <div class="shop-more-buttons">
      {#if shopMoreDetails?.family?.name}
        <a href={contextedUrl(shopMoreDetails?.family?.url)} class="c_button c_shopmore-button"
          >{shopMoreDetails?.family?.name}</a
        >
      {/if}

      {#if shopMoreDetails?.brand?.name}
        <a href={contextedUrl(shopMoreDetails?.brand?.url)} class="c_button c_shopmore-button"
          >{shopMoreDetails?.brand?.name}</a
        >
      {/if}

      {#if shopMoreDetails?.brandFamily?.name}
        <a href={contextedUrl(shopMoreDetails?.brandFamily?.url)} class="c_button c_shopmore-button"
          >{shopMoreDetails?.brandFamily?.name}</a
        >
      {/if}

      {#if shopMoreDetails?.subFamily?.name}
        <a href={contextedUrl(shopMoreDetails?.subFamily?.url)} class="c_button c_shopmore-button"
          >{shopMoreDetails?.subFamily?.name}</a
        >
      {/if}
    </div>
  </div>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .shop-more-container {
    padding: 24px 16px;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 1440px;
    margin-inline: auto;

    @include desktop-min-width {
      flex-direction: row;
      padding: 16px 48px;
      align-items: center;
      justify-content: space-between;
    }

    .shop-more-buttons {
      display: flex;
      gap: 8px;
      justify-content: flex-start;
      margin-right: 16px;

      @include desktop-min-width {
        justify-content: flex-end;
        max-width: 470px;
        flex-wrap: wrap;
        margin: 0;
      }

      .c_shopmore-button {
        font-weight: 400;
        font-size: 16px;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background-color: $secondary-gray-02;
        color: $neutral-dark-01;
      }
    }

    .left-part {
      .shop-more-label {
        font-weight: 700;
        font-size: 20px;
        line-height: 22px;
        margin: 0 0 16px 0;

        @include desktop-min-width {
          font-size: 36px;
          line-height: 40px;
          margin: 0 0 20px 0;
        }
      }
      .c_form .form-group {
        margin: 0;
      }
    }
    .right-part {
      padding-bottom: 10px;
      overflow-x: auto;
      width: 100%;

      @include desktop-min-width {
        width: unset;
      }
    }
  }
</style>
